import React from 'react';
import { Link } from 'react-router-dom';
import { ROOT_PATH, ADMIN_ROOT_PATH } from '../../../constants/routes';
import { UserContext } from '../../../Application';
import { PERMISSIONS, ifPermission, hasPermissions } from '../../../constants/authentication/permissions';

const Navigation = ({ logOut, currentPath }) => (
    <UserContext.Consumer>
        {(user) => (
            <div className="ckp-admin-nav">
                <ul className="ckp-admin-nav-menu">
                    <li className="ckp-admin-nav-menu-item">
                        <Link className={'ckp-admin-nav-menu-link is-portal'} to={ADMIN_ROOT_PATH}>
                            Portal
                        </Link>
                        <span className="ckp-admin-nav-menu-item-line" />
                    </li>
                    {hasPermissions(user, PERMISSIONS.VIEW_LINEUP) ||
                    hasPermissions(user, PERMISSIONS.VIEW_CONTRACTS_INBOX) ||
                    hasPermissions(user, PERMISSIONS.VIEW_SIGNED_CONTRACTS_INBOX) ? (
                        <li className="ckp-admin-nav-menu-item">
                            <Link
                                className={`ckp-admin-nav-menu-link ${ifPermission(
                                    user,
                                    PERMISSIONS.VIEW_LINEUP,
                                    'is-line-up',
                                    'is-contracts'
                                )}`}
                                to={ROOT_PATH}
                            >
                                {ifPermission(user, PERMISSIONS.VIEW_LINEUP, 'Event view', 'Contracts')}
                            </Link>
                        </li>
                    ) : null}
                </ul>
                <ul className="ckp-admin-nav-profile">
                    <a className="ckp-admin-nav-menu-link is-log-out" onClick={logOut}>
                        Log Out
                    </a>
                </ul>
            </div>
        )}
    </UserContext.Consumer>
);

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/admin/layout/Navigation.js